import { Outlet } from "react-router-dom";
import { Navbar } from "./navbar";
import { BottomNav } from "./bottom-nav";
import { useLanguage } from "@/contexts/language-context";

interface MainLayoutProps {
  user?: {
    username: string;
    email: string;
  };
  unreadNotifications?: number;
  onLogout?: () => void;
}

export function MainLayout({ unreadNotifications }: MainLayoutProps) {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col relative">
      {/* Accessibility: skip link */}
      <a href="#main-content" className="skip-link">
        {t("common.skipToContent")}
      </a>

      {/* Ambient glows for depth - hidden on mobile for performance */}
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
        <div className="hidden sm:block absolute top-0 left-1/4 w-64 sm:w-80 md:w-96 h-64 sm:h-80 md:h-96 bg-[#89D7B7]/4 rounded-full blur-3xl" />
        <div className="hidden sm:block absolute bottom-0 right-1/4 w-64 sm:w-80 md:w-96 h-64 sm:h-80 md:h-96 bg-[#792CA2]/4 rounded-full blur-3xl" />
        <div className="hidden md:block absolute top-1/2 right-0 w-56 md:w-72 h-56 md:h-72 bg-[#C13383]/3 rounded-full blur-3xl" />
      </div>

      <Navbar unreadNotifications={unreadNotifications} />

      <main id="main-content" className="flex-1 relative z-10">
        <div className="container mx-auto px-3 sm:px-4 py-4 sm:py-6 md:py-8 lg:py-10 pb-24 md:pb-12">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </div>
      </main>

      {/* Mobile bottom navigation (md:hidden) */}
      <BottomNav unreadNotifications={unreadNotifications} />
    </div>
  );
}
